var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.85548C19.7232 8.48958 21 10.792 21 12C21 14 17.5 19 12 19C10.0636 19 8.37512 18.3802 7 17.4898M14 5.22655C13.3678 5.08102 12.7001 5 12 5C6.5 5 3 10 3 12C3 12.73 3.46629 13.8597 4.32592 15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87868 14.1218C11.0503 15.2933 12.9497 15.2933 14.1213 14.1218C15.2929 12.9502 15.2929 11.0507 14.1213 9.87913M11.5 9.04217C10.9063 9.142 10.3368 9.42099 9.87868 9.87913C9.42054 10.3373 9.14155 10.9067 9.04172 11.5005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L20 4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoff);
export default __webpack_public_path__ + "static/media/eye off.8a92a7d6d44940c2dc8c9c84886243ca.svg";
export { ForwardRef as ReactComponent };